import { insightAreaSelectPermissionHolderType } from "../../../../actions/insight-area-actions"

import buildPermissionHoldersConnector from "../../../common/permission-holders/build-permission-holders-connector"
import PermissionHoldersViewWidget from "../../../common/permission-holders/PermissionHoldersViewWidget"

export default buildPermissionHoldersConnector(
    "insightAreas",
    insightAreaSelectPermissionHolderType
)(PermissionHoldersViewWidget)
